import { isoToFlag } from '../crm/country-codes';

const CZ_MON_GEN = ['ledna', 'února', 'března', 'dubna', 'května', 'června', 'července', 'srpna', 'září', 'října', 'listopadu', 'prosince'];

export function klientInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return ((parts[0]![0] ?? '') + (parts[parts.length - 1]![0] ?? '')).toUpperCase() || '?';
}

export function fmtEur(n: number | null | undefined): string {
  if (n == null) return '-';
  return `${new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 0 }).format(n)} €`;
}

export function fmtDay(ymd: string | null | undefined): string {
  if (!ymd) return '-';
  const [y, m, d] = ymd.split('-').map(Number);
  if (!y || !m || !d) return ymd;
  return `${d}. ${m}. ${y}`;
}

export function fmtLongDay(ymd: string | null | undefined): string | null {
  if (!ymd) return null;
  const [y, m, d] = ymd.split('-').map(Number);
  if (!y || !m || !d || m < 1 || m > 12) return null;
  return `${d}. ${CZ_MON_GEN[m - 1]} ${y}`;
}

export function fmtDateTime(value: string | null | undefined): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('cs-CZ', { day: 'numeric', month: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date);
}

export function marketFlag(code: string | null | undefined): string {
  const c = (code ?? '').trim();
  if (!c || c.toLowerCase() === 'global') return '🌐';
  return /^[A-Za-z]{2}$/.test(c) ? isoToFlag(c.toUpperCase()) : '🌐';
}

export function webHost(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    return new URL(url.startsWith('http') ? url : `https://${url}`).hostname.replace(/^www\./, '');
  } catch {
    return url.replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/\/$/, '');
  }
}

export function webHref(url: string): string {
  return url.startsWith('http') ? url : `https://${url}`;
}
